import { toast } from 'react-toastify';

import { nextProjectUrl } from '@shared/constants/urls';

import type { RewardPool } from '@api/types/rewardPools';

import { useIsJoinedToPool } from '@store:web/components/entities/rewardPool/model/useIsJoinedToPool';
import { useJoinRewardPool } from '@store:web/components/entities/rewardPool/model/useJoinRewardPool';
import { openUrl } from '@utilities/browser';
import { getErrorMessage } from '@utilities/errors/getErrorMessage';

import { ListItemButton } from '../../List/ListItemButton';

type SwapButtonProps = {
  rewardPool: RewardPool;
  locked: boolean;
  isLoading: boolean;
};

export const SwapButton = ({ rewardPool, locked, isLoading }: SwapButtonProps) => {
  const { mutateAsync: joinRewardPool, isPending: isJoinRewardPoolLoading } = useJoinRewardPool(
    rewardPool.id,
  );

  const { isJoined: isSelfJoined, isLoading: isSelfJoinedRewardPoolLoading } = useIsJoinedToPool({
    rewardPool,
  });

  const onClickHandler = async () => {
    try {
      if (!isSelfJoined) {
        await joinRewardPool({ rewardPool });
      }

      openUrl(nextProjectUrl.swap('/'));
    } catch (error) {
      const errorMessage = getErrorMessage(error);

      toast.error(errorMessage);
    }
  };

  return (
    <ListItemButton
      onClick={onClickHandler}
      locked={locked}
      isLoading={isLoading || isJoinRewardPoolLoading || isSelfJoinedRewardPoolLoading}
    >
      Magic Swap
    </ListItemButton>
  );
};
